module.exports = __webpack_public_path__ + "img/7fb39550-9db3-4c0b-99c7-ecdcea64c26b.0a777742.png";